import { render, staticRenderFns } from "./PedidosFacturacion.vue?vue&type=template&id=c107b570"
import script from "./PedidosFacturacion.vue?vue&type=script&lang=js"
export * from "./PedidosFacturacion.vue?vue&type=script&lang=js"
import style0 from "./PedidosFacturacion.vue?vue&type=style&index=0&id=c107b570&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports